import { styles } from 'consts';
import styled, { css } from 'styled-components';

const { whiteDarker, primaryBlack, boxShadow } = styles;

const setOpacity = ({ isVisible }: { isVisible: boolean }) => (isVisible ? 1 : 0);
const setHeight = ({ isVisible }: { isVisible: boolean }) => (isVisible ? 'auto' : '0');
const setVisible = ({ isVisible }: { isVisible: boolean }) => (isVisible ? 'visible' : 'hidden');

export const PaymentNotificationContainer = styled.div<{ isVisible: boolean }>`
  ${props =>
    props.isVisible &&
    css`
      margin: 0.5rem 0 3.5rem 0;
    `}

  font-size: 0.75rem;
  width: 100%;
  height: ${setHeight};
  margin: 0.5rem 0;
  background-color: ${whiteDarker};
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.5rem 0 ${boxShadow};
  opacity: 0;
  opacity: ${setOpacity};
  visibility: ${setVisible};
  transition: opacity 400ms ease-in-out, height 400ms ease-in-out;

  p {
    color: ${primaryBlack};
    margin: 0.5rem;
    text-align: center;
  }
`;

export const PaymentNotificationBold = styled.p`
  font-weight: bold;
  overflow-wrap: break-word;
`;
